
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'FlowSummary',
})
export default class FlowSummary extends NodeFormMixin {}
